<template>
  <form @submit.prevent="saveContact">
    <div class="modal-body">
      <!-- CURRENT IMAGE PREVIEW -->
      <div v-if="imagePreview" class="mb-3 text-center">
        <label class="fw-bold">Current Contact Image</label>
        <div>
          <img
            :src="imagePreview"
            class="img-fluid rounded"
            style="max-height: 200px"
          />
        </div>
      </div>

      <!-- IMAGE UPLOAD -->
      <div class="mb-3">
        <label class="form-label">Change Contact Page Image</label>
        <input type="file" class="form-control" @change="handleImage" />
        <div v-if="newPreview" class="mt-2 text-center">
          <small class="text-muted">New image preview:</small>
          <img
            :src="newPreview"
            class="img-fluid rounded"
            style="max-height: 200px"
          />
        </div>
      </div>
    </div>

    <div class="modal-footer border-top-pink">
      <button class="btn btn-success" :disabled="loading">
        <span v-if="loading" class="spinner-border spinner-border-sm"></span>
        <span v-else><i class="bi bi-save"></i> Save</span>
      </button>
    </div>
  </form>
</template>

<script>
import axios from "axios";

export default {
  name: "ContactContent",
  data() {
    return {
      contact_image: null, // file to upload
      imagePreview: "", // current image from backend
      newPreview: "", // preview of selected new file
      loading: false,
    };
  },
  mounted() {
    this.loadContent();
  },
  methods: {
    // Load current image from backend
    loadContent() {
      axios
        .get("/contact-content")
        .then((res) => {
          if (res.data && res.data.contact_image) {
            this.imagePreview = res.data.contact_image; // full URL returned by backend
          }
        })
        .catch(() => {
          console.error("Failed to load contact image");
        });
    },

    handleImage(e) {
      const file = e.target.files[0];
      if (file) {
        this.contact_image = file;
        this.newPreview = URL.createObjectURL(file); // live preview
      }
    },

    saveContact() {
      if (!this.contact_image) {
        alert("Please select an image first.");
        return;
      }

      this.loading = true;
      const formData = new FormData();
      formData.append("contact_image", this.contact_image);

      axios
        .post("/save-contact-content", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {
          alert("Contact page image updated successfully");
          this.newPreview = "";
          this.loadContent(); // reload current image
        })
        .catch(() => {
          alert("Error updating contact image");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
img {
  border: 2px solid #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
</style>
